import DatepickerComponent from './Datepicker.component';
export default DatepickerComponent;